export class Accordion {
  constructor(target, resetOnEveryClick = false) {
    this.section = target;

    this.accordionBtns = this.section.querySelectorAll('.item-button');
    this.lastClickedId = null;
    this.resetAllActive = resetOnEveryClick;

    this.contentBoxTransitionTime = 300;

    this.triggers = this.section.querySelectorAll('.item-button');
    this.contents = this.section.querySelectorAll('.collapsible');
    this.defaultTrigger = [...this.triggers].find(el => el.classList.contains('active'));
    this.defaultTabContent = [...this.contents].find(el => el.classList.contains('active'));
  }

  init() {
    this.loading(false);

    for (const [index, btn] of this.accordionBtns.entries()) {
      const parentContainer = btn.closest('.item') || null;
      const msgContainer = parentContainer.querySelector('.collapsible') || null;

      if (!parentContainer || !msgContainer) return;

      const childId = `msg-${ index}`;

      msgContainer.id = childId;
      msgContainer.setAttribute('aria-labelledby', `btn-${index}`);
      msgContainer.setAttribute('aria-controlledby', `btn-${index}`);

      btn.id = `btn-${ index}`;
      btn.setAttribute('aria-label', `${index + 1} of ${this.accordionBtns.length}`);
      btn.setAttribute('aria-expanded', false);
      btn.setAttribute('aria-controls', childId);
      btn.addEventListener('click', this.handleClick.bind(this));
    }
  }

  loading(isLoading = true) {
    this.section.classList.toggle('loading', isLoading);
  }

  handleActiveState(e) {
    const contentBox = e.target.nextElementSibling;

    e.target.focus();
    e.target.setAttribute('aria-expanded', true);
    contentBox.setAttribute('aria-expanded', true);
    contentBox.style.height = `${contentBox.scrollHeight }px`;

    setTimeout(() => (contentBox.style.height = 'auto'), this.contentBoxTransitionTime);
  }

  handleNotActiveState(e) {
    const contentBox = e.target.nextElementSibling;

    e.target.blur();
    e.target.setAttribute('aria-expanded', false);
    contentBox.setAttribute('aria-expanded', false);

    contentBox.style.height = `${contentBox.scrollHeight }px`;

    setTimeout(() => (contentBox.style.height = 0), 1);
    setTimeout(() => (contentBox.style.height = undefined), this.contentBoxTransitionTime);
  }

  handleClick(e) {
    if (e.target.id === this.lastClickedId) {
      this.lastClickedId = e.target.id;
      if (e.target.classList.contains('active')) {
        e.target.classList.remove('active');
        this.handleNotActiveState(e);
      } else {
        e.target.classList.add('active');
        this.handleActiveState(e);
      }

      return;
    }

    if (this.resetAllActive) {
      this.accordionBtns.forEach((btn) => {
        if (btn.classList.contains('active')) {
          btn.classList.remove('active');
          const contentBox = btn.closest('.item').getElementsByTagName('.collapsible');

          contentBox.style.height = 0;
        }
      });
    }

    if (this.lastClickedId !== e.target.id) {
      this.lastClickedId = e.target.id;
      e.target.classList.toggle('active');

      if (e.target.classList.contains('active')) {
        this.handleActiveState(e);
      } else {
        this.handleNotActiveState(e);
      }
    }
  }
}
